<template>
  <section class="data-personal">
    <v-container grid-list-xl fluid>
      <v-form v-model="valid">
        <v-layout wrap>
          <v-flex md3>
            <v-menu
              :close-on-click="false"
              v-model="showDatePicker"
              :nudge-right="40"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="personal.birthday"
                label="Data de nascimento"
                hint="DD/MM/AAAA"
                persistent-hint
                prepend-icon="mdi-calendar"
                :rules="[validationRules.required]"
              />
              <v-date-picker
                v-model="date"
                no-title
                @input="showDatePicker = false"
                locale="pt-br"
                @change="setDate"
              />
            </v-menu>
          </v-flex>

          <v-flex md3>
            <v-combobox
              v-model="personal.gender"
              :items="genre_options"
              label="Sexo"
              :rules=[validationRules.required]
            />
          </v-flex>

          <v-flex md3>
            <v-combobox
              v-model="personal.marital_status"
              :items="marital_options"
              label="Estado Civil"
              :rules=[validationRules.required]
            />
          </v-flex>

          <v-flex md3>
            <v-combobox
              v-model="personal.schooling"
              :items="schooling_options"
              label="Grau de Escolaridade"
            />
          </v-flex>

          <v-subheader style="width: 100%;">
            Documentos
          </v-subheader>

          <v-flex md3>
            <v-text-field
              v-model="personal.cpf"
              label="CPF"
              :mask="masks.cpf"
              :rules=[validationRules.required]
              :disabled="true"
            />
          </v-flex>

          <v-flex md3>
            <v-text-field
              v-model="personal.rg"
              label="RG"
            />
          </v-flex>

          <v-subheader style="width: 100%;">
            Contatos
          </v-subheader>

          <v-flex md3>
            <v-text-field
              v-model="personal.cellphone"
              label="Celular"
              :mask="masks.cellphone"
              :rules=[validationRules.required]
            />
          </v-flex>

          <v-flex md3>
            <v-text-field
              v-model="personal.phone"
              label="Telefone"
              :mask="masks.phone"
              :rules=[validationRules.required]
            />
          </v-flex>

          <v-flex xs12>
            <v-layout justify-center>
              <v-spacer />
              <v-btn
                large
                flat
                :disabled="loading.show"
                to="/"
              >
                Cancelar
              </v-btn>

              <v-btn
                large
                color="success"
                @click="updatePersonal"
                :loading="loading.show"
                :disabled="loading.show || !valid"
              >
                <v-icon left>mdi-content-save</v-icon>
                Salvar
              </v-btn>
              <v-spacer />
            </v-layout>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </section>
</template>

<script>
import masks from '@/mixins/masks';
import validationRules from '@/mixins/validation-rules';

export default {
  name: 'DataPersonal',
  data() {
    return {
      date: null,
      showDatePicker: false,
      picker: null,
      dateFormatted: null,
      masks,
      genre_options: [
        'Masculino',
        'Feminino',
      ],
      marital_options: [
        'Solteiro(a)',
        'Casado(a)',
        'Divorciado(a)',
        'Viúvo(a)',
        'Separado(a)',
        'Companheiro(a)',
      ],
      schooling_options: [
        'Fundamental',
        'Médio',
        'Técnico',
        'Graduado',
        'Pós Graduado',
      ],
      validationRules,
      personal: {},
      valid: false,
    };
  },
  watch: {
    user(val) {
      this.personal = {
        ...val,
        birthday: this.formatDate(val.birthday),
      };
    },
  },
  methods: {
    save(date) {
      this.$refs.birthdayMenu.save(date);
    },
    updatePersonal() {
      this.$store.dispatch('updateUser', { userId: this.user.id, ...this.personal });
    },
    formatDate(date) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) {
        return null;
      }
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    setDate() {
      this.personal.birthday = this.formatDate(this.date);
      this.date = this.parseDate(this.personal.birthday);
    },
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>

<style scoped lang="scss">
// .data-personal {}
</style>



// WEBPACK FOOTER //
// src/components/account/profile/DataPersonal.vue